import { createReducer } from "@reduxjs/toolkit";
import {
  DELETE_SYSTEM_NOTIFICATION_LOADING,
  DELETE_SYSTEM_NOTIFICATION_ERROR,
  DELETE_SYSTEM_NOTIFICATION_SUCCESS,
  STOP_RETIREMENT_SUCCESS,
  COMPLETE_BILLING_ORDER_SUCCESS,
} from "~/store/action_types";
import { ANGULAR_INIT } from "~/store/action_types";

const ACCOUNT_CANCELLED_SYSTEM_NOTIFICATION = "SubscriptionCancelledSystemNotification";

const PAYMENT_FAILED_SYSTEM_NOTIFICATION = "PaymentFailedSystemNotification";

const system_notifications = createReducer([], (builder) => {
  builder
    .addCase(ANGULAR_INIT, (state, action) => {
      const { response = {} } = action;
      const { system_notifications = [] } = response;
      state = system_notifications;
      return state;
    })
    .addCase(STOP_RETIREMENT_SUCCESS, (state) => {
      return state.filter((item) => item.class !== ACCOUNT_CANCELLED_SYSTEM_NOTIFICATION);
    })
    .addCase(COMPLETE_BILLING_ORDER_SUCCESS, (state) => {
      return state.filter((item) => item.class !== PAYMENT_FAILED_SYSTEM_NOTIFICATION);
    })
    .addMatcher(
      (action) =>
        [
          DELETE_SYSTEM_NOTIFICATION_ERROR,
          DELETE_SYSTEM_NOTIFICATION_LOADING,
          DELETE_SYSTEM_NOTIFICATION_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        const { id = 0 } = action;

        if (id > 0) {
          return state.filter((item) => item.id !== id);
        }

        return state;
      }
    );
});

export default system_notifications;
